// Extracted from markdown.utils.ts so light consumers (format-compat, report utils) don't
// transitively import the remark/unified packages, which are ESM-only and unparseable by
// Jest's CJS transform. markdown.utils.ts re-exports this to preserve existing call sites.
export function isLikelyHtml(value: string | null | undefined): boolean {
  if (!value) return false;
  // Allow leading whitespace and any number of leading HTML comments, then
  // require a real tag head: <tagname[ attrs]> or <tagname/>.
  //
  // Accepts: "<p>...", "  <div>...", "<!-- generated --><p>..."
  // Rejects: "< 5 mg ibuprofen", "<-- ... -->", and "Summary:\n<p>..."
  //          (leading text is a backend contract bug, not HTML).
  // Rejects markdown documents that contain HTML islands further in the body —
  // those should still go through the markdown renderer.
  return /^\s*(?:<!--[\s\S]*?-->\s*)*<[a-z][a-z0-9]*\b[^<]*>/i.test(value);
}
